import { PlaybookCardsSection } from '@/playbooks/components/PlaybookCardsSection'
import { Footer } from '@/shared/components/Footer'
import { Header } from '@/shared/components/Header'
import { useUserContext } from '@/shared/contexts/userContext'
import { useToast } from '@/shared/hooks/useToast'
import { Hero } from '@/static-pages/components/Hero'
import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const Index: React.FC = () => {
  const { isLoading, user } = useUserContext()
  const [searchParams] = useSearchParams()
  const { toast } = useToast()
  const navigate = useNavigate()

  useEffect(() => {
    document.title = 'Mydra | Automate business tasks with AI-powered workflows'
  }, [])

  useEffect(() => {
    const plan = searchParams.get('plan')
    const success = searchParams.get('success')
    const cancelled = searchParams.get('cancelled')

    if (!user) {
      return
    }

    if (success === 'true') {
      toast({
        title: 'Plan updated successfully',
        description: `Your subscription has been updated to the ${plan} plan.`,
      })
    } else if (cancelled === 'true') {
      toast({
        variant: 'destructive',
        title: 'Plan subscription cancelled',
        description: `Subscription to ${plan} plan has been cancelled.`,
      })
    }

    if (!searchParams.has('success')) {
      navigate('/dashboard')
    }
  }, [user, searchParams, toast, navigate])

  if (isLoading) {
    return null
  }

  return (
    <div className="overflow-hidden bg-white">
      <Header />
      <Hero />

      <div className="mx-auto grid grid-cols-1 md:grid-cols-12">
        <div className="md:col-span-10 md:col-start-2">
          <main className="mx-auto flex flex-col items-center px-6 md:px-8 md:pt-6">
            <PlaybookCardsSection
              maxPlaybooks={6}
              filters={{ isCommunity: true }}
              disableInfiniteScroll
            />
          </main>
        </div>

        <div className="md:col-span-12 md:mx-auto">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Index
